/**
 * Given a search term, constructs a search url.
 *
 * @param {string} searchTerm - Search term.
 * @param {string} alias - Locale alias.
 * @returns {string} - Builded url.
 */
export const searchUrlBuilder = (searchTerm: string, alias: string): string => `/${alias}/search?q=` + encodeURIComponent(searchTerm)

/**
 * Calculates if customer is logged or not
 *
 * @param {Object} customer - Customer Object.
 * @returns {boolean} - A value that indicates if a customer is logged or not.
 */
export const isUserLogged = (customer): boolean => customer?.customerId && typeof customer?.customerId === 'string' && !customer?.isGuest

/**
 * Given an absolute url.
 *
 * @param {string} host - host localized by site.
 * @param {string} locale - Locale alias.
 * @param {string} path - path to redirect.
 * @returns {string} - Builded url.
 */

export const getAbsoluteUrl = (host: string, locale: string, path: string): string => {
    const baseUrl = new URL('https://' + host)
    const relativePath = '/' + locale + path
    const url = new URL(relativePath, baseUrl)
    return url.href
}

/**
 * Generates a Basic Authorization credential for SFRA.
 *
 * @param {Object} customParams - The custom parameters object.
 * @param {string} customParams.passwordStorefront - The password for the storefront.
 * @returns {string|boolean} The Basic Authorization credential if passwordStorefront is provided, otherwise false.
 */
export const getAuthorizationCredentialSFRA = (customParams) => {
    if (customParams?.passwordStorefront) {
        return 'Basic ' + btoa('storefront' + ':' + customParams.passwordStorefront)
    } else return false
}

export const createRedirectUrl = (url: string, hostLink: string, locale: string, site: string): string => {
    let urlSplitted: string[] = []
    switch (true) {
        // Caso 1: URL che contiene sia {site} che {locale}
        case url.includes(`/s/${site}/${locale}/`):
            urlSplitted = url.split(`/s/${site}/${locale}/`)
            return 'https://' + hostLink + '/' + locale + '/' + urlSplitted[1]

        // Caso 2: URL che contiene solo {site}
        case url.includes(`/s/${site}/`):
            urlSplitted = url.split(`/s/${site}/`)
            return 'https://' + hostLink + '/' + locale + '/' + urlSplitted[1]

        // Caso predefinito: URL non riconosciuto
        default:
            return url
    }
}

export * from './meta-tags'
